import { useEffect } from "react";
import { useFeatureFlagVariantKey } from "posthog-js/react";
import { useOrganization } from "~hooks/useOrganization";
import { FeatureFlagKeyEnum } from "~graphql/sdk";
import { chance } from "~lib/sentry/beforeSend";
import { useLocalStorage } from "usehooks-ts";

export type CheckoutVariant = "spc" | "legacy";

const CHANCE = chance(4); // 1 in 4 = 25%
const STORAGE_KEY = "single-page-checkout"; // This key can be change to "bust" the cache

export const useCheckoutVariant = (): CheckoutVariant => {
  const { hasFeature } = useOrganization();

  // Simple chance function to enable SPC. This overrides Posthog feature flag while we experiment
  // with tracking non-logged in users, which DO NOT get the Posthog feature flag assigned.
  const [diceRoll, setDiceRoll] = useLocalStorage<boolean>(
    STORAGE_KEY,
    () => CHANCE
  );

  useEffect(() => {
    // useLocalStorage returns an initial value for missing keys but does not persist it automatically.
    if (typeof window === "undefined") {
      return;
    }

    if (window.localStorage.getItem(STORAGE_KEY) === null) {
      setDiceRoll((current) => current);
    }
  }, [setDiceRoll]);

  const orgHasSinglePage = hasFeature(FeatureFlagKeyEnum.SinglePageCheckout);

  const posthogVariant = useFeatureFlagVariantKey("single-page-checkout");

  if (!orgHasSinglePage) return "legacy";
  if (posthogVariant === "spc" || diceRoll) return "spc";
  return "legacy";
};
